import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyC-ZmgQFNtoU7EseCb_6S0k2tSlFfmWv0M",
  authDomain: "attendance-app-85322.firebaseapp.com",
  projectId: "attendance-app-85322",
  storageBucket: "attendance-app-85322.firebasestorage.app",
  messagingSenderId: "22726625012",
  appId: "1:22726625012:web:b1f3368bd8fdab7e2580a1"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export default app;
